import React from "react"
import { Button, Card, CardBody, CardText, CardTitle, Col, Row, Table } from "reactstrap"

import { connect } from "react-redux"

import { useWallet } from "../libs/useMetaMaskWallet"

const apiUrl = "https://leads.idexo.io"
const testData = {
    email: "some@email.com",
    source: "specialnftcheck"
}

const submitLead = () => {
    fetch(apiUrl, {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(testData)
    }).then(console.log)
}
const SpecialNFTCheck = (props) => {
    const wallet = useWallet()
    const { networkOptionStatus, validationStatus, pointBalance } = props

    return (
        <>
            <div style={{ overflow: "auto" }}>
                <CardTitle className="h3">Request Early Access</CardTitle>
                <CardText className="P font-size-12 text-uppercase">
                    Click on the button below to request your early access to this special free NFT verification.
                </CardText>

                <Button color="primary" className="waves-effect w-lg w-100 mt-2" onClick={console.log("insert magic here")}>
                    REQUEST EARLY ACCESS NOW
                </Button>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    networkOptionStatus: state.commonReducer.networkOptionStatus,
    validationStatus: state.commonReducer.validationStatus,
    pointBalance: state.commonReducer.pointBalance
})

export default connect(mapStateToProps)(SpecialNFTCheck)
